import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { AirportI18n } from '@common/interfaces/master/airport_i18n_all';
import {
  FirstBaggagePassengerMap,
  FirstBaggagePnr,
  PassengerBaggageInfor,
} from '@common/interfaces/mybooking/order-baggage.interface';
import { MasterJsonKeyPrefix } from '@conf/asw-master.config';
import { DialogClickType } from '@lib/interfaces';
import { DialogDisplayService } from '@lib/services';

@Injectable({ providedIn: 'root' })
export class BaggageRequestService extends ServicingBaseClass {
  airportI18nAll!: AirportI18n;
  constructor(private _dialogService: DialogDisplayService) {
    super();
  }

  // (共通No.1) 空港名称取得処理
  onHandleCommonNo1(airport_code?: string): string {
    return this.airportI18nAll?.[String(airport_code)]?.[0].airport_name ?? '';
  }

  getBaggageService(
    airBoundId?: string,
    travelerId?: string,
    firstBaggage?: FirstBaggagePnr
  ): FirstBaggagePassengerMap {
    // FIXME: sdk chưa có interface
    const firstBaggagePassengerMap =
      (firstBaggage?.[String(airBoundId)]?.[String(travelerId)] as PassengerBaggageInfor) ??
      ({} as PassengerBaggageInfor);
    return firstBaggagePassengerMap as FirstBaggagePassengerMap;
  }

  openDialogPromise(messageId: string): Promise<DialogClickType> {
    return new Promise((resolve) => {
      this._dialogService
        .openDialog({ message: MasterJsonKeyPrefix.DYNAMIC + messageId })
        .buttonClick$.subscribe((result) => resolve(result.clickType));
    });
  }

  destroy() {}
}
